var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }